export interface Address {
  city: string;
  country: string;
  country_code: string;
  county: string;
  postcode: string;
  road: string;
  state: string;
  suburb: string;

  house_number?: string;
  village?: string;
  shop?: string;
  town?: string;
}

export function getAddressString(address: Address, isProperty: boolean = false) {
  if(address == null){
    return "";
  }
  const displayAddress = [];
  if (address.house_number && !isProperty) {
    displayAddress.push(`${address.road} ${address.house_number}`);
  } else {
    displayAddress.push(`${address.road}`);
  }

  if (address.town) {
    displayAddress.push(address.town);
  } else if (address.village) {
    displayAddress.push(address.village);
  } else if (address.city) {
    displayAddress.push(address.city);
  }

  return displayAddress.join(", ");
}

export function getAddressCity(address: Address) {
  const displayAddress = [];

  if (address.town) {
    displayAddress.push(address.town);
  } else if (address.village) {
    displayAddress.push(address.village);
  } else if (address.city) {
    displayAddress.push(address.city);
  }
  return displayAddress.join(", ");
}

export function getAddressStreet(address: Address) {
  const displayAddress = [];
  if (address.house_number) {
    displayAddress.push(`${address.road} ${address.house_number}`);
  } else {
    displayAddress.push(`${address.road}`);
  }
  return displayAddress.join(", ");
}

export function getAddressPostcode(address: Address) {
  if (address.postcode) {
    return address.postcode;
  } else {
    return "";
  }

}

export function getTrackingLocation(address: Address) {
  const displayAddress = [];

  if (address.city) {
    displayAddress.push(address.city);
  } else if (address.village) {
    displayAddress.push(address.village);
  }
  displayAddress.push(`${address.road}`);

  return displayAddress.join(", ");
}

export function parseAddressFromString(addressString: string | null) {
  if(addressString == null || addressString.length === 0){
    return [];
  }
  const address = addressString.split(",");

  const displayAddress = [];
  // street
  if (address[0]) {
    displayAddress.push(address[0]);
  }

  // postcode
  if (address[1]){
    displayAddress.push(address[1]);
  }

  // city
  if (address[2]){
    displayAddress.push(address[2]);
  }

  return displayAddress;
}
